'use client';

import { useEffect } from 'react';
import { showUpdateReadyToast, watchServiceWorkerUpdates } from '@/shared/utils/sw-updates';

/**
 * Faza J — Service Worker registration + update notification.
 *
 * - Register `/sw.js` la mount (logica în `watchServiceWorkerUpdates`)
 * - O versiune nouă instalată → notificare „Versiune nouă disponibilă”
 * - User initiates reload manually (no forced refresh mid-session)
 * - La demontare oprește ascultarea și verificarea periodică: altfel o remontare dubla
 *   notificarea. E montat în layout.tsx în afara <Providers>, ca remontarea de după hidratare
 *   (formatul numeric ro-RO, NumberFormatProvider) să nu-l mai atingă deloc.
 *
 * Note: only runs in production (dev SW interferes cu HMR).
 */
export function SwRegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    // Skip în dev — Next.js HMR conflict
    if (process.env.NODE_ENV !== 'production') return;

    try {
      // navigator.serviceWorker poate arunca (iframe izolat, origine opacă) — worker-ul e opțional
      return watchServiceWorkerUpdates(navigator.serviceWorker, showUpdateReadyToast);
    } catch (err) {
      console.warn('[SW] Registration failed:', err);
    }
  }, []);

  return null;
}
